/** @file transportBindings: Space, frame steps and the K keys, one global table (active on the Pose screen). */
import type { Binding } from '@zilo/pose3d-shortcuts/types';

/** `when: poseScreen` is evaluated by `installShortcuts`; off elsewhere, so Space still presses a focused button there. */
const t = (id: string, keys: string): Binding => ({ id, keys, context: 'global', when: 'poseScreen' });

/**
 * The chords the viewport and the timeline both used to bind, now one binding each: Space play / pause, `,` and `.`
 * step a frame, K keys the selected joints, Shift+K keys the whole pose. Handlers: `transportHandlers`.
 */
export const transportBindings: Binding[] = [
  t('transport.play', 'Space'),
  t('transport.prevFrame', 'Comma'),
  t('transport.nextFrame', 'Period'),
  t('transport.keyJoint', 'KeyK'),
  t('transport.keyAll', 'Shift+KeyK'),
];
